import React, { Component } from "react";
import CartContext from "./CartContext";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { OrderDetails } from "./OrderDetails";
import { SideMenu } from "./SideMenu";
import { BiSave, BiRefresh, BiUpload, BiDownload } from "react-icons/bi";
import { OrderHistory } from "./OrderHistory";
import { Navigate } from "react-router-dom";
import { LoadSpinner } from "./LoadSpinner";

import {
  PurchaseByRawMaterialReport,
  PurchaseGstReport,
  RawMaterialsPurchaseOrderSummaryReport,
  SalesAndPurchaseSummaryReport,
  SalesGstReport,
  SalesReport,
} from "./Reports2";

import {
  InputGroup,
  Stack,
  FormControl,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

import Select from "react-select";
import {} from "react-bootstrap";
import { AccountLedger } from "./AccountLedger";
import { LedgerBook } from "./AccountLedgerBook";

export class Reports extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawMaterialsInventory: [],
      firstloaded: false,
      selectedReport: "",
      dateRange: "Today",
      reportlist: [
        { id: 1, name: "1. Sales by Product" },
        { id: 2, name: "2. Sales by Category" },
        { id: 3, name: "3. Sales by Order" },
        { id: 4, name: "4. Top Selling Products" },
        { id: 5, name: "5. Top Purchasing Customers" },
        { id: 6, name: "6. Products Purchase Summary - by Products" },
        { id: 7, name: "7. Product Purchase Order(PO) Summary" },
        { id: 8, name: "8. RawMaterial Purchase Summary - by Material" },
        { id: 9, name: "9. RawMaterials Purchase Order(PO) Summary" },
        { id: 10, name: "10. Sales Report(GST)- Detailed" },
        { id: 11, name: "11. Purchases Report(GST)- Detailed" },
        { id: 12, name: "12. Sales & Purchases Summary" },
        { id: 13, name: "13. Account Ledger Book- Detailed" },
        { id: 14, name: "14. Account Ledger - Summary" },
        { id: 15, name: "15. Product - Price" },
        // { id: 10, name: "GSTR-3B" },
      ],
    };
  }
  GetRawMaterialsInventories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetRawMaterialsInventories/" +
        this.context.storeId,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawMaterialsInventory: data }, () => {});
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
  };
  OnReportChange = (e) => {
    const { name, value } = e.target;
    this.setState({ selectedReport: value }, () => {});
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.firstloaded == false) {
      this.state.firstloaded = true;
      this.GetRawMaterialsInventories();
    }
  };

  render() {
    if (this.context.storeId === "") {
      // return <Navigate to="/UserLogin" />;
      return <Navigate to="/Home" />;
    }
    return (
      <>
        <div className="Container-fluid m-0 p-0 ">
          <div>
            <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
              <h3>
                &nbsp;&nbsp;<b>All Reports</b>
              </h3>
            </Navbar>
          </div>
          <div className="bg-light px-3">
            <Table className="bg-light m-0 p-0">
              <tr className="border-0">
                <td width="100%">
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Select Report
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.selectedReport}
                      onChange={(e) => {
                        this.OnReportChange(e);
                      }}
                    >
                      <option value=""></option>
                      {this.state.reportlist.map((m) => (
                        <>
                          <option value={m.id}>{m.name}</option>
                        </>
                      ))}
                    </Form.Select>
                  </InputGroup>
                </td>
                {/* <td width="30%">
                      <InputGroup className="mb-1">
                        <InputGroup.Text id="basic-addon1">
                          Date Range
                        </InputGroup.Text>
                        <Form.Select
                          value={this.state.dateRange}
                          onChange={(e) => {
                            this.OnDateRangeChanged(e);
                          }}
                        >
                          <option value="Today">Today</option>
                          <option value="Yesterday">Yesterday</option>
                          <option value="Last 3 Days">Last 3 Days</option>
                          <option value="Last 7 Days">Last 7 Days</option>
                          <option value="This Month">This Month</option>
                          <option value="Last Month">Last Month</option>
                          <option value="Last 3 Months">Last 3 Months</option>
                          <option value="All">All</option>
                        </Form.Select>
                      </InputGroup>
                    </td> */}
              </tr>
            </Table>
            {this.state.selectedReport == 1 ? (
              <>
                <SalesByProductReport
                  dateRange={this.state.dateRange}
                ></SalesByProductReport>
              </>
            ) : this.state.selectedReport == 2 ? (
              <>
                <SalesByCategoryReport
                  dateRange={this.state.dateRange}
                ></SalesByCategoryReport>
              </>
            ) : this.state.selectedReport == 3 ? (
              <>
                <OrderHistory report={true}></OrderHistory>
              </>
            ) : this.state.selectedReport == 4 ? (
              <>
                <TopSellingProducts report={true}></TopSellingProducts>
              </>
            ) : this.state.selectedReport == 5 ? (
              <>
                <TopPurchasingCustomers report={true}></TopPurchasingCustomers>
              </>
            ) : this.state.selectedReport == 6 ? (
              <>
                <PurchaseByProductReport
                // dateRange={this.state.dateRange}
                ></PurchaseByProductReport>
              </>
            ) : this.state.selectedReport == 7 ? (
              <>
                <PurchaseSummaryReport
                // dateRange={this.state.dateRange}
                ></PurchaseSummaryReport>
              </>
            ) : this.state.selectedReport == 8 ? (
              <>
                <PurchaseByRawMaterialReport
                  // dateRange={this.state.dateRange}
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                ></PurchaseByRawMaterialReport>
              </>
            ) : this.state.selectedReport == 9 ? (
              <>
                <RawMaterialsPurchaseOrderSummaryReport
                // dateRange={this.state.dateRange}
                ></RawMaterialsPurchaseOrderSummaryReport>
              </>
            ) : this.state.selectedReport == 10 ? (
              <>
                <SalesGstReport> </SalesGstReport>
              </>
            ) : this.state.selectedReport == 11 ? (
              <>
                <PurchaseGstReport></PurchaseGstReport>
              </>
            ) : this.state.selectedReport == 12 ? (
              <>
                <SalesAndPurchaseSummaryReport></SalesAndPurchaseSummaryReport>
              </>
            ) : this.state.selectedReport == 13 ? (
              <>
                <LedgerBook></LedgerBook>
              </>
            ) : this.state.selectedReport == 14 ? (
              <>
                <AccountLedger isReport={true}></AccountLedger>
              </>
            ) : this.state.selectedReport == 15 ? (
              <>
                <ProductPriceReport></ProductPriceReport>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </>
    );
  }
}

export class SalesByProductReport extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  OnDateRangeChanged = (e) => {
    const { value } = e.target;
    this.setState({ dateRange: value, result: [] });
  };

  GetSalesByProduct = async () => {
    try {
      this.ShowLoadSpinner();
      const url = `${process.env.REACT_APP_API}Reports/GetSalesByProduct/${
        this.context.storeId
      }/${encodeURIComponent(this.state.dateRange)}/${this.context.GetTicks(
        this.state.startDate,
      )}/${this.context.GetTicks(this.state.endDate)}`;

      const resp = await fetch(url);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const data = await resp.json();

      if (!Array.isArray(data)) {
        console.warn("Expected array from server", data);
        this.setState({ result: [] });
        return;
      }

      // Minimal mapping — trust server fields, but normalize numbers & round for display
      const normalized = data.map((it) => ({
        productId: it.productId ?? it.productID ?? it.ProductId,
        name: it.name ?? it.Name ?? "",
        categoryName: it.categoryName ?? it.CategoryName ?? "",
        price: Number.isFinite(Number(it.price))
          ? Number(Number(it.price).toFixed(2))
          : 0,
        totqty: Number.isFinite(Number(it.totqty))
          ? Number(Number(it.totqty).toFixed(2))
          : 0,
        gstPercent: Number.isFinite(Number(it.gstPercent))
          ? Number(Number(it.gstPercent).toFixed(2))
          : 0,
        tax: Number.isFinite(Number(it.gstAmount ?? it.tax))
          ? Number(Number(it.gstAmount ?? it.tax).toFixed(2))
          : 0,
        total: Number.isFinite(Number(it.total))
          ? Number(Number(it.total).toFixed(2))
          : 0,
        effectiveInclusive: !!it.effectiveInclusive,
      }));

      this.setState({ result: normalized });
    } catch (err) {
      console.error("GetSalesByProduct failed", err);
      this.setState({ result: [] });
    } finally {
      this.HideLoadSpinner();
    }
  };

  DownloadToCSV = () => {
    const headings =
      "#,ProductName,Category,TotalQty,GST,SalesAmount,Tax Amount";
    let reportDetails = "Sales By Product Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate,
    );

    let rows = "";
    (this.state.result || [])
      .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
      .forEach((m, idx) => {
        const safeName = String(m.name || m.productName || "").replace(
          /[\r\n,]+/g,
          " ",
        );
        const safeCategory = String(m.categoryName || "").replace(
          /[\r\n,]+/g,
          " ",
        );
        const qty = Number(m.totqty || 0).toFixed(2);
        const sales = Number(m.price || 0).toFixed(2);
        const tax = Number(m.tax || 0).toFixed(2);
        const gst = Number(m.gstPercent || 0).toFixed(2);
        // const total = Number(m.total || 0).toFixed(2);

        rows += `${idx + 1},${safeName},${safeCategory},${qty},${gst},${sales},${tax}\n`;
      });

    const result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for Firefox
    element.click();
    element.remove();
  };

  PrintReport = () => {
    const { result, dateRange, startDate, endDate } = this.state;
    const settings = this.context.storeSettings || {};

    if (!result || result.length === 0) return;

    const storeName = settings.storeName || "";
    const storeAddress = settings.storeAddress || "";
    const storeEmail = settings.storeEmailId || "";
    const storePhone = settings.storePhoneNo || "";

    const reportTitle = "Sales By Product Report";
    const dateSection = this.context.GetDateResult(
      dateRange,
      startDate,
      endDate,
    );

    // Build printable HTML
    let html = `
    <html>
      <head>
        <title>${reportTitle}</title>
        <style>
          body { font-family: Arial; padding: 20px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #888; padding: 6px; text-align: right; }
          th.text-start, td.text-start { text-align: left; }
          h2, h3, h4 { text-align: center; margin: 0; padding: 4px; }

          .store-header {
            text-align: center;
            margin-bottom: 10px;
          }
          .store-header .name {
            font-size: 22px;
            font-weight: bold;
          }
          .store-header .address {
            font-size: 14px;
            margin-top: 4px;
          }
          .store-header .contact {
            font-size: 13px;
            margin-top: 2px;
          }
        </style>
      </head>

      <body>

        <div class="store-header">
          <div class="name">${storeName}</div>
          <div class="address">${storeAddress}</div>
          <div class="contact">
            ${storeEmail ? "Email: " + storeEmail : ""}
            ${storePhone ? "&nbsp;&nbsp; Phone: " + storePhone : ""}
          </div>
        </div>

        <h2>${reportTitle}</h2>
        <h4>${dateSection}</h4>

        <table>
          <thead>
            <tr>
              <th>No.</th>
              <th class="text-start">Product Name</th>
              <th class="text-start">Category</th>
              <th>Tot.Qty</th>
              <th>GST %</th>
              <th>Sales Amount</th>
              <th>Tax Amount</th>
            </tr>
          </thead>
          <tbody>
  `;

    result
      .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
      .forEach((m, i) => {
        html += `
        <tr>
          <td>${i + 1}</td>
          <td class="text-start">${m.name}</td>
          <td class="text-start">${m.categoryName}</td>
          <td>${Number(m.totqty).toFixed(2)}</td>
          <td>${Number(m.gstPercent).toFixed(2)}%</td>
          <td>${Number(m.price).toFixed(2)}</td>
          <td>${Number(m.tax).toFixed(2)}</td>
        </tr>
      `;
      });

    html += `
          </tbody>
        </table>

        <script>
          window.onload = () => { window.print(); };
        </script>

      </body>
    </html>
  `;

    // Open in new tab
    const printWindow = window.open("", "_blank");
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
  };

  componentDidMount = () => {
    // this.GetSalesByProduct(); // enable if you want auto-load
  };

  onStartDateChange = (date) => this.setState({ startDate: date });
  onEndDateChange = (date) => this.setState({ endDate: date });

  getProductName = (row) => {
    if (!row) return "";
    if (row.name && String(row.name).trim() !== "") return row.name;
    const prods = this.context.prods || [];
    const pid = row.productId || row.productID || row.productId;
    const found = prods.find(
      (p) =>
        p.id === pid ||
        String(p.id) === String(pid) ||
        p.productId === pid ||
        String(p.productId) === String(pid),
    );
    return found ? found.productName || found.name || "" : "";
  };

  formatCurrency = (value) => {
    const locale = this.context.storeSettings?.defaultLocale || "en-IN";
    const currency = this.context.storeSettings?.defaultCurrency || "INR";
    return Number(value || 0).toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
      style: "currency",
      currency,
    });
  };

  render() {
    const { result } = this.state;
    const storeSettings = this.context.storeSettings || {};
    const currencyLocale = storeSettings.defaultLocale || "en-IN";

    const salesTotal = (result || []).reduce(
      (a, v) => a + Number(v.price || 0),
      0,
    );
    const taxTotal = (result || []).reduce((a, v) => a + Number(v.tax || 0), 0);
    const grandTotal = (result || []).reduce(
      (a, v) => a + Number(v.total || 0),
      0,
    );

    return (
      <>
        <div>
          {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : null}

          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={this.OnDateRangeChanged}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                    </Form.Select>
                  </InputGroup>
                </td>

                {this.state.dateRange === "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : null}

                <td>
                  <Button onClick={() => this.GetSalesByProduct()}>
                    Show Report
                  </Button>
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button variant="success" onClick={this.PrintReport}>
                      🖨️ Print/PDF
                    </Button>
                  ) : null}
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button
                      variant="danger"
                      onClick={() => this.DownloadToCSV()}
                    >
                      <BiDownload size="20" /> Download(CSV)
                    </Button>
                  ) : null}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={this.OnDateRangeChanged}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>

                  {this.state.dateRange === "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : null}
                </td>

                <td>
                  <Button onClick={() => this.GetSalesByProduct()}>
                    Show Report
                  </Button>
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button
                      variant="danger"
                      onClick={() => this.DownloadToCSV()}
                    >
                      <BiDownload size="20" /> Download
                    </Button>
                  ) : null}
                </td>
              </tr>
            </>
          )}

          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th className="text-center">No.</th>
                <th className="text-start">Product Name</th>
                <th className="text-start">Category</th>
                <th>Tot.Qty</th>
                <th>GST %</th>
                <th>
                  Total Sales Amount
                  <br />[
                  {result && result.length > 0
                    ? salesTotal.toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th>
                <th>
                  Tax Amount
                  <br />[
                  {result && result.length > 0
                    ? taxTotal.toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th>
                {/* <th>
                  Total
                  <br />[
                  {result && result.length > 0
                    ? grandTotal.toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th> */}
              </tr>
            </thead>

            <tbody>
              {result && result.length > 0 ? (
                result
                  .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
                  .map((m, i) => (
                    <tr key={`${m.name || m.productId || "prod"}-${i}`}>
                      <td className="text-center">{i + 1}</td>
                      <td className="text-start">
                        {this.getProductName(m) || m.name}
                      </td>
                      <td className="text-start">{m.categoryName}</td>
                      <td>{Number(m.totqty).toFixed(2)}</td>
                      {/* NEW GST % column */}
                      <td className="text-end">
                        {m.gstPercent
                          ? Number(m.gstPercent).toFixed(2) + "%"
                          : m.effectiveInclusive
                            ? // inclusive → compute from server inclusive logic (fallback)
                              ((Number(m.tax) / Number(m.price)) * 100).toFixed(
                                2,
                              ) + "%"
                            : // exclusive → compute fallback
                              (
                                (Number(m.tax) /
                                  (Number(m.price) - Number(m.tax))) *
                                100
                              ).toFixed(2) + "%"}
                      </td>
                      <td className="text-end">
                        {this.formatCurrency(m.price)}
                      </td>
                      <td className="text-end">{this.formatCurrency(m.tax)}</td>
                      {/* <td className="text-end">
                        {this.formatCurrency(m.total)}
                      </td> */}
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center">
                    No data
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}

export class SalesByCategoryReport extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
  };

  // GetSalesByCategory = () => {
  //   this.ShowLoadSpinner();
  //   fetch(
  //     process.env.REACT_APP_API +
  //       "Reports/GetSalesByCategory/" +
  //       this.context.storeId +
  //       "/" +
  //       this.state.dateRange +
  //       "/" +
  //       this.context.GetTicks(this.state.startDate) +
  //       "/" +
  //       this.context.GetTicks(this.state.endDate)
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.setState({ result: data });
  //       this.HideLoadSpinner();
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //       this.HideLoadSpinner();
  //       // alert("GetOrders fetch err:" + error);
  //     });
  // };

  GetSalesByCategory = async () => {
    try {
      this.ShowLoadSpinner();

      const response = await fetch(
        `${process.env.REACT_APP_API}Reports/GetSalesByCategory/${
          this.context.storeId
        }/${this.state.dateRange}/${this.context.GetTicks(
          this.state.startDate,
        )}/${this.context.GetTicks(this.state.endDate)}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      this.setState({ result: data });
    } catch (error) {
      console.error("Error fetching sales by category:", error);
    } finally {
      this.HideLoadSpinner();
    }
  };

  DownloadToCSV = () => {
    var headings = "#,ProductName,TotalQty,SalesAmount";
    var reportDetails = "Sales By Product Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate,
    );
    var rows = "";
    this.state.result
      .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
      .map((m, i) => {
        rows +=
          i +
          1 +
          "," +
          m.name +
          "," +
          Number(m.totqty).toFixed(2) +
          "," +
          Number(m.price).toFixed(2);
        // +
        // "," +
        // Number(
        //   (m.price * this.context.taxDetails.taxPercentage) / 100
        // ).toFixed(2) +
        // "," +
        // Number(
        //   m.price + (m.price * this.context.taxDetails.taxPercentage) / 100
        // ).toFixed(2)
        rows += "\n";
      });

    var result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  componentDidMount = () => {
    //this.GetSalesByProduct();
  };

  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };
  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  render() {
    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      {/* <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option> */}
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy HH:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td>
                  <Button onClick={(e) => this.GetSalesByCategory()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                  {this.state.dateRange == "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>
                  <Button onClick={(e) => this.GetSalesByCategory()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          )}

          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <th className="text-center">No.</th>
              <th className="text-start">Product Name</th>
              <th>Tot.Qty</th>
              {/* <th>
                Sales in Amount
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce((a, v) => (a = a + Number(v.price)), 0)
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th>
              <th>
                Tax
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce(
                      (a, v) =>
                        (a =
                          a +
                          Number(
                            v.price * this.context.taxDetails.taxPercentage
                          ) /
                            100),
                      0
                    )
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th> */}
              <th>
                Total
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce(
                      (a, v) =>
                        (a =
                          a +
                          v.price +
                          Number(
                            v.price * this.context.taxDetails.taxPercentage,
                          ) /
                            100),
                      0,
                    )
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th>
            </thead>
            <tbody>
              {this.state.result.length > 0 &&
                this.state.result
                  .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
                  .map((m, i) => (
                    <>
                      <tr>
                        <td className="text-center">{i + 1}</td>
                        <td className="text-start">{m.name}</td>
                        <td>{Number(m.totqty).toFixed(1)}</td>
                        {/* <td>
                          {m.price.toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {(
                            (m.price * this.context.taxDetails.taxPercentage) /
                            100
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td> */}
                        <td>
                          {(
                            m.price +
                            (m.price * this.context.taxDetails.taxPercentage) /
                              100
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            },
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}

export class TopSellingProducts extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
  };

  TopSellingProductsReportSummary = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Reports/TopSellingProductsReportSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate),
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ result: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
        // alert("GetOrders fetch err:" + error);
      });
  };
  DownloadToCSV = () => {
    var headings = "#,Product Name, Total Orders(Count),TotalQty,SalesAmount";
    var reportDetails = "Top Selling Products Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate,
    );
    var rows = "";
    this.state.result
      .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
      .map((m, i) => {
        rows +=
          i +
          1 +
          "," +
          m.name +
          "," +
          m.count +
          "," +
          Number(m.totqty).toFixed(2) +
          "," +
          Number(m.price).toFixed(2);
        //+
        // "," +
        // Number(
        //   (m.price * this.context.taxDetails.taxPercentage) / 100
        // ).toFixed(2) +
        // "," +
        // Number(
        //   m.price + (m.price * this.context.taxDetails.taxPercentage) / 100
        // ).toFixed(2)
        rows += "\n";
      });

    var result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  componentDidMount = () => {
    //this.TopSellingProductsReportSummary();
  };

  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };
  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  render() {
    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td>
                  <Button
                    onClick={(e) => this.TopSellingProductsReportSummary()}
                  >
                    Show Report
                  </Button>
                </td>
                <td className="">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                  {this.state.dateRange == "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>
                  <Button
                    onClick={(e) => this.TopSellingProductsReportSummary()}
                  >
                    Show Report
                  </Button>
                </td>
                <td className="">
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          )}

          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <th className="text-center">No.</th>
              <th className="text-start">Product Name</th>
              <th className="text-start">Total Orders(Count)</th>
              <th>Tot.Qty</th>
              <th>
                Sales in Amount
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce((a, v) => (a = a + Number(v.price)), 0)
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th>
              {/* <th>
                Tax
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce(
                      (a, v) =>
                        (a =
                          a +
                          Number(
                            v.price * this.context.taxDetails.taxPercentage
                          ) /
                            100),
                      0
                    )
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th>
              <th>
                Total
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce(
                      (a, v) =>
                        (a =
                          a +
                          v.price +
                          Number(
                            v.price * this.context.taxDetails.taxPercentage
                          ) /
                            100),
                      0
                    )
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th> */}
            </thead>
            <tbody>
              {this.state.result.length > 0 &&
                this.state.result
                  .sort((a, b) => (a.count < b.count ? 1 : -1))
                  .map((m, i) => (
                    <>
                      <tr>
                        <td className="text-center">{i + 1}</td>
                        <td className="text-start">{m.name}</td>
                        <td className="text-start">{m.count}</td>
                        <td>{Number(m.totqty).toFixed(1)}</td>
                        <td>
                          {m.price.toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            },
                          )}
                        </td>
                        {/* <td>
                          {(
                            (m.price * this.context.taxDetails.taxPercentage) /
                            100
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {(
                            m.price +
                            (m.price * this.context.taxDetails.taxPercentage) /
                              100
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td> */}
                      </tr>
                    </>
                  ))}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}
export class TopPurchasingCustomers extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
  };

  TopPurchasingCustomersReportSummary = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Reports/TopPurchasingCustomersReportSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate),
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ result: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
        // alert("GetOrders fetch err:" + error);
      });
  };
  DownloadToCSV = () => {
    var headings =
      "#,Customer Name, Tot.Qty Purchased,Purchased Amount,Tax,Total";
    var reportDetails = "Top Purchasing Customers - Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate,
    );
    var rows = "";
    this.state.result
      .sort((a, b) => (a.price < b.price ? 1 : -1))
      .map((m, i) => {
        rows +=
          i +
          1 +
          "," +
          m.name +
          "," +
          Number(m.totqty).toFixed(2) +
          "," +
          Number(m.price).toFixed(2) +
          "," +
          Number(
            (m.price * this.context.taxDetails.taxPercentage) / 100,
          ).toFixed(2) +
          "," +
          Number(
            m.price + (m.price * this.context.taxDetails.taxPercentage) / 100,
          ).toFixed(2);
        rows += "\n";
      });

    var result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  componentDidMount = () => {
    //this.TopSellingProductsReportSummary();
  };

  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };
  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  render() {
    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td>
                  <Button
                    onClick={(e) => this.TopPurchasingCustomersReportSummary()}
                  >
                    Show Report
                  </Button>
                </td>
                <td className="">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                  {this.state.dateRange == "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>
                  <Button
                    onClick={(e) => this.TopPurchasingCustomersReportSummary()}
                  >
                    Show Report
                  </Button>
                </td>
                <td className="">
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          )}

          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <th className="text-center">No.</th>
              <th className="text-start">Customer Name</th>
              <th>Tot.Qty Purchased</th>
              <th>
                Purchased Amount
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce((a, v) => (a = a + Number(v.price)), 0)
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th>
              <th>
                Tax
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce(
                      (a, v) =>
                        (a =
                          a +
                          Number(
                            v.price * this.context.taxDetails.taxPercentage,
                          ) /
                            100),
                      0,
                    )
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th>
              <th>
                Total
                <br />[
                {this.state.result.length > 0 &&
                  this.state.result
                    .reduce(
                      (a, v) =>
                        (a =
                          a +
                          v.price +
                          Number(
                            v.price * this.context.taxDetails.taxPercentage,
                          ) /
                            100),
                      0,
                    )
                    .toLocaleString(this.context.storeSettings.defaultLocale, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                      style: "currency",
                      currency: this.context.storeSettings.defaultCurrency,
                    })}
                ]
              </th>
            </thead>
            <tbody>
              {this.state.result.length > 0 &&
                this.state.result
                  .sort((a, b) => (a.price < b.price ? 1 : -1))
                  .map((m, i) => (
                    <>
                      <tr>
                        <td className="text-center">{i + 1}</td>
                        <td className="text-start">{m.name}</td>
                        <td>{Number(m.totqty).toFixed(1)}</td>
                        <td>
                          {m.price.toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            },
                          )}
                        </td>
                        <td>
                          {(
                            (m.price * this.context.taxDetails.taxPercentage) /
                            100
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            },
                          )}
                        </td>
                        <td>
                          {(
                            m.price +
                            (m.price * this.context.taxDetails.taxPercentage) /
                              100
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            },
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}
export class PurchaseByProductReport extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
  };

  GetPurchasesByProduct = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetPurchasesByProduct/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate),
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ result: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
        // alert("GetOrders fetch err:" + error);
      });
  };

  DownloadToCSV = () => {
    var headings = "#,Product Name, Tot.Qty, Purchases in Amount,Tax,Total";
    var reportDetails = "Purchase Summary by Products - Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate,
    );
    var rows = "";
    this.state.result
      .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
      .map((m, i) => {
        rows +=
          i +
          1 +
          "," +
          m.name +
          "," +
          Number(m.totqty).toFixed(2) +
          "," +
          Number(m.price).toFixed(2) +
          "," +
          Number((m.price * m.tax) / 100).toFixed(2) +
          "," +
          Number(m.price + (m.price * m.tax) / 100).toFixed(2);
        rows += "\n";
      });

    var result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };
  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };
  componentDidMount = () => {
    //this.GetPurchasesByProduct();
  };

  render() {
    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td>
                  <Button onClick={(e) => this.GetPurchasesByProduct()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                  {this.state.dateRange == "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>
                  <Button onClick={(e) => this.GetPurchasesByProduct()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          )}
          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <th className="text-center">No.</th>
              <th className="text-start">Product Name</th>
              <th>Tot.Qty</th>
              <th>
                Purchases in Amount
                <br />[
                {this.state.result
                  .reduce((a, v) => (a = a + Number(v.price)), 0)
                  .toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                ]
              </th>
              <th>
                Tax Amount
                <br />[
                {this.state.result
                  .reduce((a, v) => (a = a + Number(v.price * v.tax) / 100), 0)
                  .toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                ]
              </th>
              <th>
                Total
                <br />[
                {this.state.result
                  .reduce(
                    (a, v) => (a = a + v.price + Number(v.price * v.tax) / 100),
                    0,
                  )
                  .toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                ]
              </th>
            </thead>
            <tbody>
              {this.state.result
                .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
                .map((m, i) => (
                  <>
                    <tr>
                      <td className="text-center">{i + 1}</td>
                      <td className="text-start">{m.name}</td>
                      <td>{Number(m.totqty).toFixed(1)}</td>
                      <td>
                        {m.price.toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          },
                        )}
                      </td>
                      <td>
                        {((m.price * m.tax) / 100).toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          },
                        )}
                      </td>
                      <td>
                        {(m.price + (m.price * m.tax) / 100).toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          },
                        )}
                      </td>
                    </tr>
                  </>
                ))}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}

export class PurchaseSummaryReport extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
  };

  GetPurchaseSummaryReport = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetPurchaseSummaryReport/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate),
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ result: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
        // alert("GetOrders fetch err:" + error);
      });
  };

  DownloadToCSV = () => {
    var headings =
      "#,CreatedOn, InvoiceNo,Tot.Purchase Amount,Tot.Purchsed Items ";
    var reportDetails = "Products Purchase Orders(PO) - Summary  - Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate,
    );
    var rows = "";
    this.state.result
      .sort((a, b) => (a.created < b.created ? 1 : -1))
      .map((m, i) => {
        rows +=
          i +
          1 +
          "," +
          this.context.GetInDateFormat(new Date(m.created)) +
          "," +
          m.invoiceNo +
          "," +
          Number(m.totAmount).toFixed(2) +
          "," +
          m.totQty;
        rows += "\n";
      });

    var result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };
  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };
  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  componentDidMount = () => {
    //this.GetPurchasesByProduct();
  };

  render() {
    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td>
                  <Button onClick={(e) => this.GetPurchaseSummaryReport()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                  {this.state.dateRange == "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>
                  <Button onClick={(e) => this.GetPurchaseSummaryReport()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          )}
          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <th className="text-center">No.</th>
              <th className="text-start">CreatedOn</th>
              <th className="text-start">InvoiceNo</th>
              <th>
                Tot.Purchase Amount
                <br />[
                {this.state.result
                  .reduce((a, v) => (a = a + Number(v.totAmount)), 0)
                  .toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                ]
              </th>
              <th>
                Tot.Purchsed Items
                <br />[
                {this.state.result.reduce(
                  (a, v) => (a = a + Number(v.totQty)),
                  0,
                )}
                ]
              </th>
            </thead>
            <tbody>
              {this.state.result
                //.sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
                .map((m, i) => (
                  <>
                    <tr>
                      <td className="text-center">{i + 1}</td>
                      <td className="text-start">
                        {this.context.GetInDateFormat(new Date(m.created))}
                      </td>
                      <td className="text-start">{m.invoiceNo}</td>
                      <td>
                        {m.totAmount.toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          },
                        )}
                      </td>
                      <td>{Number(m.totQty).toFixed(1)}</td>
                      {/* <td>
                        {m.price.toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          }
                        )}
                      </td>
                      <td>{(m.price * m.tax) / 100}</td>
                      <td>
                        {(m.price + (m.price * m.tax) / 100).toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          }
                        )}
                      </td> */}
                    </tr>
                  </>
                ))}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}

export default class ProductPriceReport extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      priceType: "Retail",
      result: [],
      loadSpinnerOpen: false,
      searchText: "",
      categoryFilter: "All",
    };
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };

  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnPriceTypeChanged = (e) => {
    this.setState({
      priceType: e.target.value,
      result: [],
      searchText: "",
      categoryFilter: "All",
    });
  };

  OnSearchTextChanged = (e) => {
    this.setState({ searchText: e.target.value });
  };

  OnCategoryFilterChanged = (e) => {
    this.setState({ categoryFilter: e.target.value });
  };

  GetProductReport = () => {
    this.ShowLoadSpinner();

    fetch(
      process.env.REACT_APP_API +
        "Product/ProductReport/" +
        this.context.storeId +
        "/" +
        this.state.priceType,
    )
      .then((response) => response.json())
      .then((data) => {
        const normalized = Array.isArray(data) ? data : [];
        this.setState({ result: normalized });
      })
      .catch((error) => {
        console.error("Error loading product report:", error);
        this.setState({ result: [] });
      })
      .finally(() => {
        this.HideLoadSpinner();
      });
  };

  getFilteredProducts = () => {
    const searchText = (this.state.searchText || "")
      .toString()
      .trim()
      .toLowerCase();
    const categoryFilter = (this.state.categoryFilter || "All").toString();
    const items = this.state.result || [];

    return items.filter((item) => {
      const name = (item.name || item.productName || "")
        .toString()
        .toLowerCase();
      const code = (item.productCode || item.code || item.sku || "")
        .toString()
        .toLowerCase();
      const category = (
        item.categoryName ||
        item.category ||
        item.categoryTitle ||
        ""
      )
        .toString()
        .toLowerCase();

      const matchesSearch =
        !searchText || name.includes(searchText) || code.includes(searchText);
      const matchesCategory =
        categoryFilter === "All" || category === categoryFilter.toLowerCase();

      return matchesSearch && matchesCategory;
    });
  };

  DownloadToCSV = () => {
    const visibleResult = this.getFilteredProducts();
    const headings = "#,Product Name,Category,Price";
    let reportDetails =
      "Products - Price Report (" + this.state.priceType + ") " + "\n";

    if (this.state.searchText) {
      reportDetails += "Filtered by search: " + this.state.searchText + "\n";
    }

    if (this.state.categoryFilter && this.state.categoryFilter !== "All") {
      reportDetails +=
        "Filtered by category: " + this.state.categoryFilter + "\n";
    }

    let rows = "";

    visibleResult
      .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
      .forEach((m, i) => {
        const productName = String(m.name || m.productName || "").replace(
          /[,\r\n]+/g,
          " ",
        );
        const categoryName = String(
          m.categoryName || m.category || m.categoryTitle || "",
        ).replace(/[ ,\r\n]+/g, " ");
        rows +=
          i +
          1 +
          "," +
          productName +
          "," +
          categoryName +
          "," +
          Number(m.price || 0).toFixed(2);
        rows += "\n";
      });

    const result = reportDetails + "\n\n" + headings + "\n" + rows;

    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });

    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";

    document.body.appendChild(element);
    element.click();
    element.remove();
  };

  componentDidMount = () => {
    this.GetProductReport();
  };

  render() {
    const visibleResult = this.getFilteredProducts();
    const totalValue = visibleResult.reduce(
      (sum, item) => sum + Number(item.price || 0),
      0,
    );
    const averagePrice =
      visibleResult.length > 0 ? totalValue / visibleResult.length : 0;
    const currencyLocale = this.context.storeSettings?.defaultLocale || "en-IN";
    const currency = this.context.storeSettings?.defaultCurrency || "INR";

    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true" />
          ) : (
            ""
          )}

          <Row className="align-items-end gx-2 gy-2 mb-2">
            <Col xs={12} sm={6} md={4} lg={3} xl={2}>
              <InputGroup>
                <InputGroup.Text>Price Type</InputGroup.Text>
                <Form.Select
                  value={this.state.priceType}
                  onChange={(e) => this.OnPriceTypeChanged(e)}
                >
                  <option value="Retail">Retail</option>
                  <option value="Wholesale">Wholesale</option>
                  <option value="SuperWholesale">Super Wholesale</option>
                </Form.Select>
              </InputGroup>
            </Col>

            <Col xs={12} sm={6} md={4} lg={3} xl={3}>
              <InputGroup>
                <InputGroup.Text>Search</InputGroup.Text>
                <FormControl
                  placeholder="Search product name or code"
                  value={this.state.searchText}
                  onChange={(e) => this.OnSearchTextChanged(e)}
                />
              </InputGroup>
            </Col>

            <Col xs={12} sm={6} md={4} lg={3} xl={3}>
              <InputGroup>
                <InputGroup.Text>Category</InputGroup.Text>
                <Form.Select
                  value={this.state.categoryFilter}
                  onChange={(e) => this.OnCategoryFilterChanged(e)}
                >
                  <option value="All">All</option>
                  {Array.from(
                    new Set(
                      (this.state.result || [])
                        .map(
                          (item) =>
                            item.categoryName ||
                            item.category ||
                            item.categoryTitle ||
                            "",
                        )
                        .filter(Boolean),
                    ),
                  ).map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Col>

            <Col xs={6} sm={3} md={2} lg={2} xl={1}>
              <Button className="w-100" onClick={() => this.GetProductReport()}>
                Show
              </Button>
            </Col>

            <Col xs={6} sm={3} md={2} lg={2} xl={1}>
              {visibleResult.length > 0 ? (
                <Button
                  className="w-100"
                  variant="danger"
                  onClick={() => this.DownloadToCSV()}
                >
                  <BiDownload size="20" />
                </Button>
              ) : (
                ""
              )}
            </Col>
          </Row>

          <div className="bg-white border rounded px-3 py-2 mb-2">
            <div className="d-flex flex-wrap gap-3 small text-muted">
              <span>
                <b>{visibleResult.length}</b> products shown
              </span>
              <span>
                <b>
                  {totalValue.toLocaleString(currencyLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency,
                  })}
                </b>{" "}
                total value
              </span>
              <span>
                <b>
                  {averagePrice.toLocaleString(currencyLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency,
                  })}
                </b>{" "}
                average price
              </span>
            </div>
          </div>

          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th className="text-center">No.</th>
                <th className="text-start">Product Name</th>
                <th className="text-start">Category</th>
                <th>
                  Price
                  <br />[
                  {totalValue.toLocaleString(currencyLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency,
                  })}
                  ]
                </th>
              </tr>
            </thead>

            <tbody>
              {visibleResult.length > 0 ? (
                visibleResult
                  .sort((a, b) => {
                    const categoryA = (
                      a.categoryName ||
                      a.category ||
                      a.categoryTitle ||
                      ""
                    ).toString();
                    const categoryB = (
                      b.categoryName ||
                      b.category ||
                      b.categoryTitle ||
                      ""
                    ).toString();
                    const cmp = categoryA.localeCompare(categoryB);
                    if (cmp !== 0) return cmp;
                    return (a.name || a.productName || "")
                      .toString()
                      .localeCompare(
                        (b.name || b.productName || "").toString(),
                      );
                  })
                  .map((m, i) => (
                    <tr key={m.id || `${m.name}-${i}`}>
                      <td className="text-center">{i + 1}</td>
                      <td className="text-start">
                        {m.name || m.productName || ""}
                      </td>
                      <td className="text-start">
                        {m.categoryName || m.category || m.categoryTitle || "-"}
                      </td>
                      <td>
                        {Number(m.price || 0).toLocaleString(currencyLocale, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 1,
                          style: "currency",
                          currency,
                        })}
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No matching products found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}
